<template>
  <div class="client_log_page">
    <h1>基础流量报表</h1>
    <div class="user-options clearfix">
      <el-select
        style="width: 160px"
        v-model="curChannel.selectValue"
        placeholder=""
      >
        <el-option
          v-for="(item, itemIndex) in channels"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        style="width: 160px"
        v-model="userStatType.selectValue"
        placeholder=""
      >
        <el-option label="dau" value="-1"></el-option>
        <el-option label="新用户" value="1"></el-option>
        <el-option label="付费用户" value="2"></el-option>
      </el-select>
      <DatePicker2
        id="picker"
        @datePickedChange="datePickedChange"
      ></DatePicker2>
      <el-button type="primary" @click="doInquery">查询</el-button>
      <el-button type="primary" @click="downloadReport">下载</el-button>
    </div>
    <div class="display-type">
      <div v-loading="loading">
        <CustomTable
          :tableList="tableList"
          :options="tableOptions"
          class="table"
        ></CustomTable>
      </div>
    </div>
  </div>
</template>

<script>
import CustomTable from '../../components/CustomTable'
import DatePicker2 from '../../components/DatePicker2'

export default {
  components: {
    CustomTable,
    DatePicker2
  },
  data() {
    return {
      curChannel: {
        selectValue: 'total',
        content: ''
      },
      userStatType: {
        selectValue: '-1',
        content: ''
      },
      channels: this.$store.state.channels,
      datePicked: [
        this.$store.getters.dateTwoDayBefore,
        this.$store.getters.dateOneDayBefore
      ],
      tableOptions: {
        defaultSort: {
          prop: 'date',
          order: 'ascending'
        },
        theader: [
          {
            name: 'date',
            label: '日期',
            sortable: true,
            fixed: true,
            width: '180px'
          },
          {
            name: 'channel',
            label: '平台',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'dau',
            label: '用户数',
            sortable: true,
            fix: true,
            width: '220px'
          },
          {
            name: 'hostListShowUsers',
            label: '首页曝光人数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'hostListShowCount',
            label: '首页曝光次数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'hostHomeExposeUserCount',
            label: '主播首页曝光人数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'hostHomeClickCount',
            label: '主播首页曝光次数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'hostPageClickUsers',
            label: '首页主播封面点击人数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'hostPageClickCount',
            label: '首页主播封面点击次数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'videoClickUser',
            label: '资料页视频按钮点击人数',
            sortable: true,
            fix: true,
            width: '160px'
          },
          {
            name: 'videoClickCount',
            label: '资料页视频按钮点击次数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'audioClickUsers',
            label: '资料页语音按钮点击人数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'audioClickCount',
            label: '资料页语音按钮点击次数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'videoCallSuccessUsers',
            label: '资料页视频拨打成功人数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'videoCallSuccessCount',
            label: '资料页视频拨打成功次数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'audioCallSuccessUsers',
            label: '资料页语音拨打成功人数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'audioCallSuccessCount',
            label: '资料页语音拨打成功次数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'callTimeUser',
            label: '用户拨打时长人数分布\n' + '(0-60s)(1-5m)(>5m)',
            sortable: true,
            fix: true,
            width: '240px'
          }
        ]
      },
      tableList: [],
      loading: true
    }
  },
  beforeCreate() {},
  created() {
    this.getList()
  },
  mounted() {},
  computed: {
    username() {
      return this.$store.getters.username
    },
    userLevel() {
      return this.$store.getters.userLevel
    },
    token() {
      return this.$store.getters.token
    }
  },
  watch: {},
  methods: {
    datePickedChange(date) {
      this.datePicked = date
    },
    //获取视频通话数据
    getList() {
      this.loading = true
      this.$axios({
        type: 'GET',
        url: this.$store.getters.path.reports_client_logs,
        withCredentials: true,
        params: {
          username: this.username,
          token: this.token,
          start: this.datePicked[0],
          end: this.datePicked[1],
          channel: this.curChannel.selectValue,
          userStatType: this.userStatType.selectValue
        }
      })
        .then(
          res => {
            if (res.data.code === 0) {
              this.tableListBuild(res.data.data)
            } else if (res.data.code === 1001) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
              this.$router.push(this.$route.query.redirect || '/login')
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
            }
          },
          err => {
            this.$message({
              showClose: true,
              message: '请求错误:' + err,
              type: 'error'
            })
          }
        )
        .then(() => {
          this.loading = false
        })
    },
    //表格数据
    tableListBuild(data) {
      this.tableList = data
    },
    doInquery() {
      this.getList()
    },
    // 生成并下载主播excel
    downloadReport() {
      window.location.href =
        this.$store.getters.path.reports_download_client_logs +
        '?token=' +
        this.token +
        '&start=' +
        this.datePicked[0] +
        '&end=' +
        this.datePicked[1] +
        '&channel=' +
        this.curChannel.selectValue +
        '&userStatType=' +
        this.userStatType.selectValue +
        '&username=' +
        this.username
    }
  }
}
</script>


<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.client_log_page {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;
  }
}
</style>
